<template lang="pug">
  hotsite-dcom
    .conteudo
      bloco#dcom_atas.-nomargin.-softpadding.-fullheight
        //- HEADER
        header(slot="header")
          titulo.-withbar.-upper Atas de Registro de Preço
        //- CONTENT
        .texto(slot="content")
          p Aqui você encontra as atas para download
          hotsite-lista(
            :itens="atas"
            :icone="'arquivo'")
          mensagem.-warn(v-if="naotematas")
            p Nenhuma ata foi encontrada no momento
        //- FOOTER
        footer(slot="footer")
          back-and-share
</template>

<style lang="scss">
  #dcom_atas {
    .lista {
      > .item {
        @extend %font_medium;
        font-size: 18px;

        &:before {
          font-family: 'FontAwesome';
          font-size: 1.4rem;
          margin-right: 15px;
        }

        &.pasta:before { content: '\f07b' }
        &.arquivo:before { content: '\f15b' }
      }
    }
  }
</style>

<script>
  import BackAndShare from 'COMPONENTS/BackAndShare'
  import Bloco from 'COMPONENTS/Bloco'
  import HotsiteDcom from 'PAGES/dcom/Base'
  import HotsiteLista from 'COMPONENTS/HotsiteLista'
  import Mensagem from 'COMPONENTS/Mensagem'
  import Titulo from 'COMPONENTS/ElementTitle'

  export default {
    components: {
      BackAndShare,
      Bloco,
      HotsiteDcom,
      HotsiteLista,
      Mensagem,
      Titulo
    },

    data () {
      return {
        atas: [],
        naotematas: false
      }
    },

    mounted () {
      setTimeout(this.ready, 2000)
    },

    methods: {
      ready () {
        this.getAtas()
      },

      // Método fictício de
      // consulta à API
      getAtas () {
        this.atas = [
          { id: 0, titulo: 'ATA A', url: 'ata-a.pdf' },
          { id: 1, titulo: 'ATA B', url: 'ata-b.pdf' },
          { id: 2, titulo: 'ATA C', url: 'ata-c.pdf' },
          { id: 3, titulo: 'ATA D', url: 'ata-c.pdf' }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Atas.vue?5f16e620